import React, { useEffect } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import BasicIntroduction from "@/components/BasicIntroduction";
import FeaturedCategories from "@/components/FeaturedCategories";
import FeaturedArticles from "@/components/FeaturedArticles";
import ShoppingDeals from "@/components/ShoppingDeals";
import EmailSubscription from "@/components/EmailSubscription";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import { useHome } from "@/hooks/use-home";
import { useLocation } from "react-router-dom";

const Index = () => {
  const { categories, articles, isLoading, error, categoryMap } = useHome();
  const location = useLocation();

  useEffect(() => {
    // Add a class to the body element for page transitions
    document.body.classList.add("page-loaded");

    // Cleanup function
    return () => {
      document.body.classList.remove("page-loaded");
    };
  }, []);

  useEffect(() => {
    // Kiểm tra xem có tham số truy vấn scrollTo không
    const queryParams = new URLSearchParams(location.search);
    const scrollTarget = queryParams.get("scrollTo");

    if (scrollTarget) {
      // Đợi một chút để đảm bảo trang đã tải xong
      setTimeout(() => {
        const element = document.getElementById(scrollTarget);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
    }
  }, [location]);

  // Animate sections as they come into view
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    // Select all elements with animation-ready class
    const animatedElements = document.querySelectorAll(".animation-ready");
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="min-h-screen w-full max-w-full">
      <Navbar />
      <main className="pt-[4.5rem] w-full max-w-full overflow-hidden">
        {" "}
        {/* Adjusted padding-top to account for header + date display */}
        <div
          className="animate-fade-in opacity-0"
          style={{ animationDelay: "0.1s" }}
        >
          <HeroSection />
        </div>
        <div className="animation-ready opacity-0 translate-y-4 transition-all duration-700">
          <BasicIntroduction />
        </div>
        {error && (
          <div className="bg-red-100 text-red-700 p-4 mx-auto max-w-full my-4 rounded-md text-center animate-pulse">
            {error}
          </div>
        )}
        <div className="animation-ready opacity-0 translate-y-4 transition-all duration-700">
          <FeaturedCategories categories={categories} isLoading={isLoading} />
        </div>
        <div className="animation-ready opacity-0 translate-y-4 transition-all duration-700">
          <FeaturedArticles
            articles={articles}
            isLoading={isLoading}
            categoryMap={categoryMap}
          />
        </div>
        <div className="animation-ready opacity-0 translate-y-4 transition-all duration-700">
          <ShoppingDeals />
        </div>
        <div className="animation-ready opacity-0 translate-y-4 transition-all duration-700">
          <EmailSubscription />
        </div>
        <div className="animation-ready opacity-0 translate-y-4 transition-all duration-700">
          <Testimonials />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
